export const filterHaveArray = (keys, key) =>
  keys.filter((k) => k.includes("[") && k.split("[")[0] === key);
